var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrarIcone)?_c('span',{staticClass:"text-success ml-1"},[_c('i',{staticClass:"fa fa-check-circle fa-lg",attrs:{"title":"Processo Recebido/Quitado"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }